<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card :header="website + ', Aanvraag #' + $route.params.id" v-if="Customer">
              <b-row>
                <b-col cols="12" md="6">
                  <b-row>
                    <b-col cols="12">
                      <h5>Uitgevoerd door</h5>
                      <hr>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" md="8">
                      <b-form-group label="Klant">
                        <b-form-input type="text" required v-model="Customer.name" :disabled="!editable" autocomplete="off"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" md="8">
                      <b-form-group label="Bedrijf">
                        <b-form-input type="text" required v-model="Customer.company.name" :disabled="!editable" autocomplete="off"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" md="4">
                      <b-form-group label="Relatienummer">
                        <b-form-input type="text" required v-model="Customer.company.relation_number" :disabled="!editable" autocomplete="off"></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" md="4">
                      <b-form-group label="Prijs per tik (€)">
                        <b-form-input type="text" required v-model="Customer.company.pricing" :disabled="!editable" autocomplete="off"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="12" md="6">
                  <b-row>
                    <b-col cols="12">
                      <h5>Basis gegevens</h5>
                      <hr>
                    </b-col>
                    <b-col cols="12" md="8">
                      <b-form-group label="Website">
                        <b-form-input type="text" required v-model="website" :disabled="!editable" autocomplete="off"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" md="6">
                      <b-form-group label="Eerste keer uitgevoerd op">
                        <b-form-input type="text" required v-model="created_at" :disabled="!editable" autocomplete="off"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" md="6">
                      <b-form-group label="Laatste keer uitgevoerd op">
                        <b-form-input type="text" required v-model="updated_at" :disabled="!editable" autocomplete="off"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="mt-4">
                <b-col cols="12" md="6">
                  <b-row>
                    <b-col cols="12">
                      <h5>Acties</h5>
                      <hr>
                    </b-col>

                    <b-col cols="12" md="4">
                      <b-form-group label="Aantal keer uitgevoerd">
                        <b-row>
                          <b-col cols="12" md="6">
                            <b-form-input type="text" required v-model="call_count" :disabled="!editable" autocomplete="off"></b-form-input>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" md="4">
                      <b-form-group label="Aantal keer gedownload">
                        <b-row>
                          <b-col cols="12" md="6">
                            <b-form-input type="text" required v-model="downloads" :disabled="!editable" autocomplete="off"></b-form-input>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row class="mt-4">
                    <b-col cols="12" md="4">
                      <b-form-group label="Aantal errors">
                        <b-row>
                          <b-col cols="12" md="6">
                            <b-form-input type="text" required v-model="errors" :disabled="!editable" autocomplete="off"></b-form-input>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row class="mt-4" v-if="errors > 0 && Request && Request.notes">
                    <b-col cols="12">
                      <h5>Laatste bekende error</h5>
                      <hr>
                    </b-col>

                    <b-col cols="12" md="8">
                      <b-form-group>
                          <pre>{{ Request.notes | clean | capitalize }}</pre>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="12" md="6">
                  <b-row>
                    <b-col cols="12">
                      <h5>Payload</h5>
                      <hr>
                    </b-col>

                    <b-col cols="12" md="8">
                      <b-form-group>
                          <pre v-if="Request && Request.payload">{{ Request.payload | pretty }}</pre>
<pre v-else>
Payload is niet (meer) beschikbaar.
---
De payload van aanvragen wordt na 24 uur automatisch verwijderd.
</pre>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>

import { getData, storeData, updateData } from '../../api';
import moment from 'moment';

export default {
  name: 'company',
  data() {
    return {
        isBusy: false,
        editable: false,
        Request: {},
        Customer: null,
    }
  },
  computed: {
    created_at () {
      if (!this.Request.created_at) return '';

      return this.formatDate(this.Request.created_at);
    },
    updated_at () {
      if (!this.Request.updated_at) return '';

      return this.formatDate(this.Request.updated_at);
    },
    call_count () {
      return this.Request.call_count || 0;
    },
    downloads () {
      return this.Request.downloads || 0;
    },
    errors () {
      return this.Request.errors || 0;
    },
    website () {
      if (!this.Request.site) return '-';

      return this.Request.site === 2 ? 'Check Sociaal' : this.Request.site === 1 ? 'VerhuurSignaal' : 'Onbekend';
    }
  },
  methods: {
    async getRequestData() {
      const { id } = this.$route.params;
      return await getData(`requests/${id}`).then((response) => {
        const { data: {data} } = response;

        this.Request = data;
      });
    },
    async getCustomerData() {
      const { customer } = this.Request;
      return await getData(`customers/${customer}`).then((response) => {
        const { data: {data} } = response;

        this.Customer = data;
      });
    },
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('DD MMMM YYYY, HH:mm');
    }
  },
  filters: {
    pretty: function(value) {
      return JSON.stringify(JSON.parse(value), null, 2);
    },
    clean: function(value) {
      const dpattern = new RegExp(/^(.*).nl/gm);
      const mpattern = new RegExp(/resulted(.*)`/gmi);

      const request = value.match(dpattern) && value.match(dpattern)[0];
      const msg = value.match(mpattern) && value.match(mpattern)[0];

      return `${request}\` ${msg}`;
    },
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  beforeMount() {
    this.getRequestData().then(() => {
      this.getCustomerData();
    });
  }
}

</script>
